import NiceModal from '@ebay/nice-modal-react';
import { requester } from 'App';
import { ShoppingProcessType } from "InitialData/constant";
import Dummy from "components/Dummy";
import P from "components/P";
import Inline from 'layouts/container/Inline';
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from 'layouts/flex/VerticalFlex';
import Center from 'layouts/wrapper/Center';
import { QRCodeSVG } from 'qrcode.react';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from 'react-toastify';
import box from "resources/img/puffu/box.png";
import addCart from "resources/img/puffu/cartWhite.png";

import order from "resources/img/puffu/coin.png";
import detailIcon from "resources/img/puffu/detail.png";
import homeBtnIcon from "resources/img/puffu/homebtn.svg";

import listIcon from "resources/img/puffu/list.png";
import mainIcon from 'resources/img/puffu/mainIcon.png';
import reviewIcon from "resources/img/puffu/review.png";

import { useTouchClick } from "shared/hooks/useTouchClick";
import { CartReducer } from 'shared/redux/reducers/shopping/CartReducer';
import style from "./HorizontalVendingLayout2.module.css";
import { closeDropdown, resetSortingState } from '../process/category/SortingDropdownReducer';
import CartResetModal from '../process/cart/CartResetModal';
import HorizontalProductDetail from './product/HorizontalProductDetail';
import HorizontalCategories2 from './category/HorizontalCategories2';
import HorizontalMainView from './category/HorizontalMainView';
import HorizontalCartList from './cart/HorizontalCartList';
import { setSelectedSubCategoryId, resetCategoryState } from '../process/category/CategoryReducer';
import categorySound from "resources/music/물방울.mp3";
import signUpSound from "resources/music/two/audio_0_안녕하세요___빠르고_간편한_무인매장_푸푸입니다.mp3";
import btnSound from "resources/music/button-pressed-38129.mp3";
import { HistoryReducer } from 'shared/redux/reducers/history/HistoryReducer';
import HorizontalProductDetail2 from './product/HorizontalProductDetail2';
import HorizontalMainView2 from './category/HorizontalMainView2';
import HorizontalCartList2 from './cart/HorizontalCartList2';
import CartProcessIcon from 'resources/img/icons/CartProcessIcon';
import PaymentProcessIcon from 'resources/img/icons/PaymentProcessIcon';
import ReceiveProcessIcon from 'resources/img/icons/ReceiveProcessIcon';
import NextProcessIcon from 'resources/img/icons/NextProcessIcon';
import BackIcon from 'resources/img/icons/BackIcon';
import HorizontalProductDetail3 from './product/HorizontalProductDetail3';




function HorizontalVendingLayout2() {
    const { id } = useParams();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const audioRef = useRef();
    const audio2Ref = useRef();
    const cartData = useSelector((state) => state.cart.products);
    const { currentSortOption, sortingOptions } = useSelector((state) => state.sortingDropdown);
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [total, setTotal] = useState(0);
    const [cartList, setCartList] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('main');
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [currentPage, setCurrentPage] = useState(1); // 페이지 상태 추가
    const [isModalOpen, setIsModalOpen] = useState(false); // 모달 상태 추가
    const [rankedProducts, setRankedProducts] = useState([]);
    const [touchStart, setTouchStart] = useState({ x: null, y: null });
    const [touchEnd, setTouchEnd] = useState({ x: null, y: null });
    const [showButtons, setShowButtons] = useState(true); // MainView의 버튼 표시 여부
    const [pagingData, setPagingData] = useState({
        totalElements: 0,
        currentPage: 0,
        hasNext: false,
        hasPrevious: false
    });
    const [viewData, setViewData] = useState({
        title: "",
        footterButtonText: "",
        currentProcess: ShoppingProcessType.CART,
        totalCount: 0,
        selectedCount: 0,
        priceSum: 0,
        vat: 0,
        deliveryFee: 0,
        discountSum: 0,
        totalAmount: 0,
        onDeleteSelectedProductsClick: () => { },
        onSubmitButtonClick: () => { },
        detailYn: false,
        detailProduct: null,
        view: null,
        reviewCount: 0,
        slideGuide: true
    });
    const [currentProductIndex, setCurrentProductIndex] = useState(0);
    const { selectedSubCategoryId } = useSelector((state) => state.category);
    const isPaymentRoute = location.pathname.includes('payment');
    const isReceiveRoute = location.pathname.includes('receiveItem');
    const shoppingProcesses = [
        { orderNo: ShoppingProcessType.CART, title: t("상품담기"), icon: addCart, size: "25px" },
        { orderNo: ShoppingProcessType.ORDER, title: t("결제하기"), icon: order, size: "30px" },
        { orderNo: ShoppingProcessType.ORDER_COMPLETE, title: t("상품수령"), icon: box, size: "25px" },
    ];

    const categoriesDetail = [
        { id: "info", categoryName: "기본정보", categoryImage: listIcon },
        { id: "detail", categoryName: "상세페이지", categoryImage: detailIcon },
        // { id: "review", categoryName: "사용후기", categoryImage: reviewIcon }
    ];
    const audio1Ref = useRef();

    const handleCategoryClick = (category) => {
        audio1Ref.current.play();
        if (category === 'all') {
            setCurrentPage(1);
            onCloseClick(category);
            fetchProductData(category, 0);
            setSelectedCategory(category);
            // navigate(`/ws/${id}/horizontal2/main2`)
            navigate(`/ws/${id}/main`)
        } else if (category === 'main') {
            setCurrentPage(1);
            onCloseClick(category);
            setShowButtons(true);
            setFilteredProducts(products);
            dispatch(resetCategoryState());
            setSelectedCategory(category);
            setViewData((prevData) => ({
                ...prevData,
                view: "main",
            }));
            // navigate(`/ws/${id}/horizontal2/main2`)
            navigate(`/ws/${id}/main`)
        } else {
            if (selectedCategory === category) {
                onCloseClick(category);
                // navigate(`/ws/${id}/horizontal2/main2`)
                navigate(`/ws/${id}/main`)
            } else {
                setCurrentPage(1);
                onCloseClick(category);
                dispatch(resetCategoryState());
                setSelectedCategory(category);
                // navigate(`/ws/${id}/horizontal2/main2`)
                navigate(`/ws/${id}/main`)

            }
        }
    };

    const onCartRemoveAllClick = () => {
        audio1Ref.current.play();
        setIsModalOpen(true); // 모달 열기
    };

    const onConfirm = () => {
        audio1Ref.current.play();
        // dispatch(CartReducer.actions.reset());
        let deviceCode = window.BRIDGE && window.BRIDGE.getDeviceCode() ? window.BRIDGE.getDeviceCode() : null;
        const data = {
            roomId: id,
            code: "clearCartProducts",
            deviceCode: deviceCode
        }
        requester.testOrder(data, (result) => {
        });
        setIsModalOpen(false); // 모달 닫기
    };

    const onCancel = () => {
        setIsModalOpen(false); // 모달 닫기
    };
    const [currentTab, setCurrentTab] = useState('info'); // 현재 탭 상태 추가


    const handleTabChange = (direction) => {
        audio1Ref.current.play();
        // const tabOrder = ['info', 'detail', 'review'];
        const tabOrder = ['info', 'detail'];

        const currentIndex = tabOrder.indexOf(currentTab);

        const newIndex = direction === 'prev'
            ? (currentIndex > 0 ? currentIndex - 1 : tabOrder.length - 1)
            : (currentIndex < tabOrder.length - 1 ? currentIndex + 1 : 0);

        setCurrentTab(tabOrder[newIndex]);
    };


    const onCloseClick = (category) => {
        audio1Ref.current.play();
        setViewData((prevData) => ({
            ...prevData,
            detailYn: false,
            detailProduct: null,
            currentProcess: ShoppingProcessType.CART

        }));
        setCurrentTab('info')
    }

    const onHomeBtnClick = () => {
        audio1Ref.current.play();
        // dispatch(CartReducer.actions.reset());
        let deviceCode = window.BRIDGE && window.BRIDGE.getDeviceCode() ? window.BRIDGE.getDeviceCode() : null;
        const data = {
            roomId: id,
            code: "clearCartProducts",
            deviceCode: deviceCode
        }
        requester.testOrder(data, (result) => {
        });
        // navigate(`/ws/${id}/horizontal2/home2`)
        navigate(`/ws/${id}/home`)
    }

    const onTestPaymentModalClick = () => {
        // if (selectedCategory === 'main') {
            if (cartData.length > 0) {
                setViewData((prevData) => ({
                    ...prevData,
                    detailYn: false,
                    detailProduct: null
                }));
                setShowButtons(false);
                // setSelectedCategory('');
                // navigate(`/ws/${id}/horizontal2/main2/payment2`, { state: { category: selectedCategory } })
                navigate(`/ws/${id}/main/payment`, { state: { category: selectedCategory } })
            } else {
                toast.error(`먼저 상품을 담아주세요.`, {
                    autoClose: 1000,
                    position: toast.POSITION.BOTTOM_CENTER
                });
            }
        // } else {
        //     if (cartData.length > 0) {
        //         setViewData((prevData) => ({
        //             ...prevData,
        //             detailYn: false,
        //             detailProduct: null
        //         }));
        //         setShowButtons(false);
        //         // setSelectedCategory('');
        //         // navigate(`/ws/${id}/horizontal2/main2/payment2`, { state: { category: selectedCategory } })
        //         navigate(`/ws/${id}/main/payment`, { state: { category: selectedCategory } })
        //     } else {
        //         toast.error(`먼저 상품을 담아주세요.`, {
        //             autoClose: 1000,
        //             position: toast.POSITION.BOTTOM_CENTER
        //         });
        //     }
        // }

        audio2Ref.current.play();

    }

    // 페이지 변경 핸들러
    const handlePageChange = (direction, page) => {
        audio2Ref.current.play();
        let newPage = direction === 'goto' ? page : pagingData.currentPage + (direction === 'next' ? 1 : -1);
        // if(id ? id : selectedCategory )
        fetchProductData(selectedSubCategoryId ? selectedSubCategoryId : selectedCategory, newPage); // currentSortOption을 유지하며 요청합니다.
        dispatch(closeDropdown());
    };

    const handleProductNavigation = async (direction) => {
        audio1Ref.current.play();

        const newIndex = currentProductIndex + (direction === 'next' ? 1 : -1);

        // 현재 페이지 내에서 이동
        if (newIndex >= 0 && newIndex < filteredProducts.length) {
            setCurrentProductIndex(newIndex);
            setViewData((prevData) => ({
                ...prevData,
                detailProduct: filteredProducts[newIndex],
                view: 'detail',
            }));
        }
        // 페이지 경계에 도달한 경우
        else {
            const newPage = direction === 'next' ? pagingData.currentPage + 1 : pagingData.currentPage - 1;

            if ((direction === 'next' && pagingData.hasNext) || (direction === 'prev' && pagingData.hasPrevious)) {
                try {
                    // 새 페이지 데이터를 요청
                    const result = await fetchProductData(selectedSubCategoryId || selectedCategory, newPage);

                    // 페이지 로드 후 첫 번째/마지막 제품으로 이동
                    const targetIndex = direction === 'next' ? 0 : result.content.length - 1;
                    setCurrentProductIndex(targetIndex);
                    setViewData((prevData) => ({
                        ...prevData,
                        detailProduct: result.content[targetIndex],
                        view: 'detail',
                    }));
                } catch (error) {
                    console.error('Failed to navigate to new page:', error);
                    toast.error('페이지 이동 중 오류가 발생했습니다.');
                }
            }
        }
    };

    // 데이터 요청 함수
    const fetchProductData = (category, page = 0, sortOption = currentSortOption) => {
        return new Promise((resolve, reject) => {
            // 로딩 시작
            dispatch(HistoryReducer.actions.setLoading(true));

            // 정렬 옵션 설정
            let sortBy = 'product.salesVolume';
            let sortDirection = 'DESC';

            switch (sortOption) {
                case '신제품순':
                    sortBy = 'id';
                    sortDirection = 'DESC';
                    break;
                case '가격 낮은 순':
                    sortBy = 'product.price';
                    sortDirection = 'ASC';
                    break;
                case '가격 높은 순':
                    sortBy = 'product.price';
                    sortDirection = 'DESC';
                    break;
                case '리뷰 많은 순':
                    sortBy = 'product.salesVolume';
                    sortDirection = 'DESC';
                    break;
            }

            // Redux에서 서브카테고리 선택 상태 가져오기
            const isCategoryInSubCategories = subCategories.some(sc => sc.id === category);

            const categoryIds = isCategoryInSubCategories
                ? [category] // category가 subCategories에 포함되면 그대로 사용
                : subCategories
                    .filter(sc => sc.parentCategoryId === category)
                    .map(sc => sc.id); // 포함되지 않으면 해당 category의 자식 ID 목록 사용

            const requestData = {
                storeCode: id,
                categoryIds,
                page,
                size: 10,
                sortBy,
                sortDirection
            };

            requester.findAllVendorProductsByCategory(requestData, (result) => {
                console.log("resultData : ", result.data)
                if (result.data) {
                    // 상태 업데이트를 동기적으로 처리
                    setFilteredProducts(result.data.content);
                    setPagingData({
                        totalPages: result.data.totalPages,
                        totalElements: result.data.totalElements,
                        currentPage: result.data.currentPage,
                        hasNext: result.data.hasNext,
                        hasPrevious: result.data.hasPrevious
                    });
                    resolve(result.data); // 여기서 result.data를 반환
                } else {
                    console.error('Failed to fetch products');
                    reject(new Error('Product fetch failed'));
                }
                dispatch(HistoryReducer.actions.setLoading(false));
            });
        });
    };

    const handleSlide = (deltaX, deltaY) => {
        const direction = deltaX > 0 ? 'next' : 'prev';
        handleTabChange(direction);
    };
    const { handleTouchStart, handleTouchEnd } = useTouchClick(
        () => { }, // 클릭 콜백은 필요 없음
        50,      // 슬라이드 감지 임계값
        handleSlide,
        true
    );
    const { handleTouchStart: homeBtnTouchStart, handleTouchEnd: homeBtnTouchEnd } = useTouchClick(onHomeBtnClick, 50);
    // const { handleTouchStart: cartResetTouchStart, handleTouchEnd: cartResetTouchEnd } = useTouchClick(onCartRemoveAllClick, 10);
    const { handleTouchStart: mainCategoryTouchStart, handleTouchEnd: mainCategoryTouchEnd } = useTouchClick(() => handleCategoryClick('main'), 50);
    const { handleTouchStart: allCategoryTouchStart, handleTouchEnd: allCategoryTouchEnd } = useTouchClick(() => handleCategoryClick('all'), 50);
    const { handleTouchStart: paymentModalTouchStart,
        handleTouchEnd: paymentModalTouchEnd
    } = useTouchClick(onTestPaymentModalClick, 50);
    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.play().catch((error) => {
                console.error('오디오 재생 오류:', error);
            });
        }
        dispatch(HistoryReducer.actions.setLoading(true));
    }, [])
    useEffect(() => {
        if (location.state && location.state.category === 'main') {

            if (filteredProducts.length > 0) {

            } else {
                // setSelectedCategory('');
                setSelectedCategory('main');
                setShowButtons(true);
            }
        }
    }, [location]);



    useEffect(() => {
        if (cartData) {
            setCartList(cartData);
        }
        const newTotal = cartData.reduce((acc, item) => acc + item.quantity * item.price, 0);
        setTotal(newTotal);
    }, [cartData]);

    useEffect(() => {

        let data = { storeCode: id }
        requester.openfindCategoryByStoreProduct(data, (result) => {
            const filteredCategories = result.data.filter(category => category.parentCategoryId == null);
            const filteredSubCategories = result.data.filter(category => category.parentCategoryId != null);
            setCategories(filteredCategories);
            setSubCategories(filteredSubCategories);
        });

    }, []);

    useEffect(() => {
        dispatch(closeDropdown());
    }, [viewData.detailYn])

    // 카테고리 변경 시 데이터 로드
    useEffect(() => {
        if (selectedCategory !== 'main') {
            fetchProductData(selectedCategory);
            // selectedCategory가 변경될 때마다 SortingDropdown 상태 초기화
            dispatch(resetSortingState());
            dispatch(closeDropdown());
            setViewData((prevData) => ({
                ...prevData,
                view: selectedCategory
            }));
        }
    }, [selectedCategory]);

    return (
        <div style={{ position: "relative", height: "100%", backgroundColor: "#ebebe1" }}>
            <audio ref={audioRef} src={signUpSound} preload="auto" />
            <audio ref={audio1Ref} src={categorySound} preload="auto" />
            <audio ref={audio2Ref} src={btnSound} preload="auto" />
            <HorizontalFlex flexStart>
                {/* <FlexChild width={"80%"} justifyContent={"center"}> */}
                <FlexChild justifyContent={"flex-start"}>
                    <VerticalFlex >
                        <FlexChild alignItems={"flex-start"}>
                            <HorizontalFlex flexStart>
                                <FlexChild width={"72%"}>
                                    <VerticalFlex>
                                        <FlexChild>
                                            <HorizontalCategories2
                                                selectedCategory={selectedCategory}
                                                mainCategoryTouchStart={mainCategoryTouchStart}
                                                mainCategoryTouchEnd={mainCategoryTouchEnd}
                                                allCategoryTouchStart={allCategoryTouchStart}
                                                allCategoryTouchEnd={allCategoryTouchEnd}
                                                categories={categories}
                                                handleCategoryClick={handleCategoryClick}
                                            />
                                        </FlexChild>
                                        <FlexChild alignItems={"flex-start"}>
                                            <HorizontalFlex flexStart>
                                                <FlexChild>
                                                    {viewData.detailYn ? (
                                                        <HorizontalProductDetail3
                                                            viewData={viewData}
                                                            setViewData={setViewData}
                                                            selectedCategory={selectedCategory}
                                                            handleCategoryClick={handleCategoryClick}
                                                            categories={categories}
                                                            handleTouchStart={handleTouchStart}
                                                            handleTouchEnd={handleTouchEnd}
                                                            onCloseClick={onCloseClick}
                                                            // handleTabChange={handleTabChange}
                                                            handleTabChange={(direction) => handleProductNavigation(direction)}
                                                            currentTab={currentTab}
                                                            setCurrentTab={setCurrentTab}
                                                            categoriesDetail={categoriesDetail}
                                                        />
                                                    ) : selectedCategory === 'main' && !isPaymentRoute && !isReceiveRoute ? (
                                                        <HorizontalMainView2
                                                            showButtons={showButtons}
                                                            setShowButtons={setShowButtons}
                                                            currentPage={currentPage}
                                                            setCurrentPage={setCurrentPage}
                                                            products={products}
                                                            filteredProducts={filteredProducts}
                                                            setFilteredProducts={setFilteredProducts}
                                                            setSelectedCategory={setSelectedCategory}
                                                            selectedCategory={selectedCategory}
                                                            rankedProducts={rankedProducts}
                                                            setViewData={setViewData}
                                                            viewData={viewData}
                                                            shoppingProcesses={shoppingProcesses}
                                                            currentProductIndex={currentProductIndex}
                                                            setCurrentProductIndex={setCurrentProductIndex}
                                                        />
                                                    ) : (
                                                        <Outlet
                                                            context={{
                                                                viewData,
                                                                fetchProductData,
                                                                setViewData,
                                                                filteredProducts,
                                                                currentPage,
                                                                setCurrentPage,
                                                                selectedCategory,
                                                                subCategories,
                                                                pagingData,
                                                                onPageChange: handlePageChange,
                                                                currentProductIndex,
                                                                setCurrentProductIndex
                                                            }}
                                                        />
                                                    )}
                                                </FlexChild>
                                            </HorizontalFlex>
                                        </FlexChild>
                                    </VerticalFlex>
                                </FlexChild>
                                <FlexChild>
                                    <div style={{ height: "100vh", display: "flex", flexDirection: "column", alignItems: "center", top: 0, backgroundColor: "white" }}>
                                        <Dummy height={"15px"} />
                                        <div className={style.paymentProcessArea}>
                                            <div className={style.paymentProcessWrap}>
                                                <div>
                                                    <Center>
                                                        <Inline>
                                                            <CartProcessIcon width={28} height={28} color={viewData.currentProcess === 1 ? "#FE531F" : "#7B7B7B"} />
                                                            <P margin={"0 0 0 5px"} font={"Pretendard"} size={24} weight={700} color={viewData.currentProcess === 1 ? "#FE531F" : "#7B7B7B"}> {shoppingProcesses[0].title}</P>
                                                        </Inline>
                                                    </Center>
                                                </div>
                                                <div style={{ width: "max-content" }}>
                                                    <NextProcessIcon width={24} height={24} color={viewData.currentProcess === 1 ? "#FE531F" : "#7B7B7B"} />
                                                </div>
                                                <div>
                                                    <Center>
                                                        <Inline>
                                                            <PaymentProcessIcon width={28} height={28} color={viewData.currentProcess === 2 ? "#FE531F" : "#7B7B7B"} />
                                                            <P margin={"0 0 0 5px"} font={"Pretendard"} size={24} weight={700} color={viewData.currentProcess === 2 ? "#FE531F" : "#7B7B7B"}> {shoppingProcesses[1].title}</P>
                                                        </Inline>
                                                    </Center>
                                                </div>
                                                <div style={{ width: "max-content" }}>
                                                    <NextProcessIcon width={24} height={24} color={viewData.currentProcess === 2 ? "#FE531F" : "#7B7B7B"} />
                                                </div>
                                                <div>
                                                    <Center>
                                                        <Inline>
                                                            <ReceiveProcessIcon width={28} height={28} color={viewData.currentProcess === 3 ? "#FE531F" : "#7B7B7B"} />
                                                            <P margin={"0 0 0 5px"} font={"Pretendard"} size={24} weight={700} color={viewData.currentProcess === 3 ? "#FE531F" : "#7B7B7B"}> {shoppingProcesses[2].title}</P>
                                                        </Inline>
                                                    </Center>
                                                </div>
                                            </div>
                                        </div>
                                        <Dummy height={"20px"} />
                                        <HorizontalCartList2 />
                                        <Dummy height={"20px"} />
                                        <div className={style.totalAmountArea} >
                                            <P textAlign={"center"} font={"Pretendard"} color={"#7B7B7B"} weight={700} size={"1vw"}>총 결제금액</P>
                                            <P font={"Pretendard"} color={"black"} weight={700} size={"1.7vw"}>{total.toLocaleString()}원</P>
                                        </div>
                                        <div style={{ height: "max-content", borderBottom: "1px dashed #7b7b7b" }} />

                                        <Dummy height={"20px"} />
                                        <div className={style.paymentButton} onPointerDown={paymentModalTouchStart} onPointerUp={paymentModalTouchEnd}>
                                            <Center>
                                                <P font={"Pretendard"} color={"white"} weight={700} size={"1.7vw"}>결제하기</P>
                                            </Center>
                                        </div>

                                        <Dummy height={"20px"} />
                                        <div className={style.cartRemoveAllBtn} onClick={onCartRemoveAllClick}>
                                            <Center>
                                                <P color={"black"} size={"1.7vw"} weight={700}>전체 취소</P>
                                            </Center>
                                        </div>
                                        <Dummy height={"20px"} />
                                        <div className={style.homeBtn} onPointerDown={homeBtnTouchStart} onPointerUp={homeBtnTouchEnd} style={{ backgroundColor: "white" }}>
                                            <Center>
                                                <Inline>
                                                    <BackIcon width={36} height={36} color={"black"} />
                                                    <Dummy width={"15px"} />
                                                    <P color={"black"} weight={700} font={"Pretendard"} size={"1.7vw"}>처음으로</P>
                                                </Inline>
                                            </Center>
                                        </div>
                                    </div>
                                </FlexChild>
                            </HorizontalFlex>
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
            </HorizontalFlex>

            <CartResetModal
                isOpen={isModalOpen}
                onRequestClose={onCancel}
                onConfirm={onConfirm}
                onCancel={onCancel}
                message={t("해당 주문상품을 삭제하시겠습니까 ?")}
                horizontal={true}
            />
        </div>
    );
}

export default HorizontalVendingLayout2;